module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Trend_16"],"path":[{"$":{"d":"M14,1a2,2,0,0,0-1.15,3.63L11.21,9,11,9a2,2,0,0,0-1.33.51L6.88,7.65a2,2,0,1,0-3.19.85L2.42,11a2,2,0,1,0,.89.45L4.58,9a2,2,0,0,0,1.75-.47l2.79,1.86a2,2,0,1,0,3-1L13.79,5,14,5a2,2,0,0,0,0-4Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Trend1_16.svg
// module id = uMUO
// module chunks = 1